export default {
  buttons: {
    cancel: "ANULUJ",
    dismiss: "Zamknij",
    add_waypoint: "dodaj cel trasy"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  search: {
    title: "Szukaj",
    placeholder: "Wprowadź lokalizację",
    enter_location: "Wprowadź lokalizację",
    help: {
      inactive: "Szukaj"
    }
  },
  filters: {
    title: "Filtr",
    amenities: {
      title: "Usługi i udogodnienia"
    },
    fuels: {
      title: "Rodzaje paliw"
    }
  },
  directions: {
    title: "Zaplanuj trasę",
    placeholder: {
      destination: "Wprowadź lokalizację",
      waypoint: "Wprowadź lokalizację"
    },
    route: {
      title: "Opcje trasy",
      avoid_tolls: "Unikaj płatnych dróg",
      avoid_highways: "Unikaj autostrad",
      title_corridor: "Odległość stacji od trasy"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# dzień} other {# dni}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min.} other {# min.}}\
`,
    button: "Szukaj"
  },
  locations: {
    title: "lokalizacje",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} z {place}"
  },
  info_window: {
    title: "Informacje o stacji",
    location_id: "ID stacji",
    services: "Usługi i udogodnienia",
    nearby: "W pobliżu",
    opening_hours: {
      title: "Godziny otwarcia",
      mon: "Pon.",
      tue: "Wt. ",
      wed: "Śr.",
      thu: "Czw.",
      fri: "Pt.",
      sat: "Sb.",
      sun: "Ndz.",
      open_twentyfourhours: "Otwarte 24h ",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Ostatnia aktualizacja",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Zaplanuj trasę"
  },
  fuels: {
    autogas_lpg: "Shell AutoGas",
    cng: "Autogas LPG",
    fuelsave_midgrade_gasoline: "Shell FuelSave 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power",
    super_premium_gasoline: "Shell V-Power Racing"
  },
  amenities: {
    air_and_water: "kompresor",
    atm: "bankomat",
    austrian_highway_sticker: "winieta austriacka",
    bank_note_acceptor: "wpłatomat",
    bottled_gas: "butle gazowe",
    carwash: "myjnia",
    clubsmart_card: "karta CLUBSMART",
    credit_card_american_express: "American Express",
    credit_card_diners_club: "Diners Club",
    credit_card_mastercard: "Mastercard",
    credit_card_visa: "Visa",
    credit_card: "karta kredytowa",
    czech_highway_sticker: "winieta czeska",
    euroshell_card: "euroShell",
    fleet_card_dkv: "karta DKV",
    fleet_card_eni: "karta ENI",
    fleet_card_esso: "karta ESSO",
    fleet_card_general: "karty flotowe",
    fleet_card_uta: "karta UTA",
    food_offerings: "Oferta gastronomiczna",
    full_service: "stacja z obsługą",
    guarded_car_park: "parking strzeżony",
    high_speed_diesel_pump: "TIR Diesel (szybki diesel)",
    hot_food: "posiłki gorące",
    hungarian_highway_sticker: "winieta węgierska",
    parking_lanes: "parking ",
    partner_loyalty_accepted: "Akceptacja kart lojalnościowych",
    restaurant: "restauracja",
    self_service: "samoobsługa",
    service_bay: "serwis",
    shell_card: "euroShell",
    shell_club_smart_extra_card: "karta CLUBSMART Premium ",
    shop: "sklep",
    shower: "prysznic",
    slovak_highway_sticker: "winieta słowacka",
    snack_food: "przekąski",
    standard_toilet: "toaleta",
    supermarket_fuel_discount: "rabat paliwowy",
    toilet: "toaleta",
    truck_parking: "parking dla TIR",
    truckport: "tylko TIR",
    twenty_four_hour: "24 godz",
    twotheloo: "2theLoo",
    vacuum: "odkurzacz"
  },
  settings: {
    title: "Ustawienia",
    tooltip: "Ustawienia",
    distance_units: {
      title: "Dystans",
      km: "km",
      miles: "mi"
    },
    language: {
      title: "Język"
    }
  }
}
